/* eslint-disable react/destructuring-assignment,react/no-array-index-key,react/require-default-props */

import React from 'react';
import PropTypes from 'prop-types';
import { PortalQualificationsDataPropType } from '../../../../CustomPropTypes/PortalPropTypes';
import { PortalQualification } from '../../PortalQualification/PortalQualification';
import './PortalQualifications.scss';

export const PortalQualifications = function (props) {
  const {
    anchor,
    title,
    titleImage,
    titleImageSize,
    content,
    qualifications,
    excludeCoursePath,
    onCtaButtonClicked,
    onEnrolInCourse,
  } = props;
  const showCourses = props.showCourses && qualifications.size === 1;
  const titleImageStyles = titleImageSize
    ? { width: titleImageSize, height: 'auto' }
    : {};

  return (
    <portal-qualifications id={anchor}>
      <div className="row portal-section">
        <div className="columns small-11 small-centered medium-10 medium-centered">
          <h2>
            <span>{title}</span>
            {titleImage !== null && (
              <img
                src={titleImage}
                alt=""
                aria-hidden="true"
                style={titleImageStyles}
              />
            )}
          </h2>
          <h4 className="portal-section-blurb">{content}</h4>
          {qualifications.map((qualification, i) => (
            <PortalQualification
              key={i}
              {...{
                qualification,
                showCourses,
                excludeCoursePath,
                onCtaButtonClicked,
                onEnrolInCourse,
              }}
            />
          ))}
        </div>
      </div>
    </portal-qualifications>
  );
};
PortalQualifications.displayName = 'PortalQualifications';
PortalQualifications.propTypes = {
  anchor: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  titleImage: PropTypes.string,
  titleImageSize: PropTypes.string,
  content: PropTypes.string.isRequired,
  qualifications: PortalQualificationsDataPropType.isRequired,
  showCourses: PropTypes.bool,
  excludeCoursePath: PropTypes.string,
  onCtaButtonClicked: PropTypes.func,
  onEnrolInCourse: PropTypes.func,
};
